import { FaBell } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import CardNotificacaoBase from "./CardNotificacaoBase";

const CardAtendimento = ({ notif }) => {
    const navigate = useNavigate();
    const info = notif.atendimento_info;

    if (!info) return null;

    const titulo = `Novo atendimento para ${info.beneficiario_nome}`;
    const descricao = `Programa: ${info.programa_nome}`;
    
    // Prioriza data do atendimento, senão data da notificação
    let dataDisplay = info.data_criacao || notif.data_criacao || "-";
    
    // Se não for pré-formatada (ex: não tem barra), tentamos formatar
    if (dataDisplay !== "-" && !dataDisplay.includes("/")) {
        try {
            dataDisplay = new Date(dataDisplay).toLocaleString("pt-BR");
        } catch (e) {
            // Mantém original se falhar
        }
    }

    const handleClick = () => {
        const identificador = info.uuid || info.id;
        navigate(`/atendimentos/edit/${identificador}`);
    };

    return (
        <CardNotificacaoBase
            notificacao={notif}
            icon={<FaBell />}
            color="primary"
            text="text-primary"
            label="Novo Atendimento"
            titulo={titulo}
            descricao={descricao}
            dataFormatada={dataDisplay}
            onClick={handleClick}
        />
    );
};

export default CardAtendimento;
